import {https , httpsFile} from './http.js';

export function index(page,currentpage){
    return httpsFile().get(`po-types?page=${page}&currentpage=${currentpage}`);
}

export function store(data){
    return httpsFile().post(`po-types`,data);
}

export function update(id,data){
    return httpsFile().post(`po-types/${id}`,data);
}

export function destroy(id){
    return httpsFile().delete(`po-types/${id}`);
}